import _extends from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isOpen", "onClose", "isFreeTrialEligible", "showSecondaryCTA", "mainCTAHref", "onMainCTAClick", "onLearnMoreClick", "isLoggedIn"];
import React from "react";
import { Heading, IconOnePass, Link, LinkButton, Span, Text } from "@catchoftheday/cg-components";
import { DEFAULT_FREE_TRIAL_DAYS, URL_ONEPASS_LANDING } from "../../../consts";
import { ContentZone } from "../../layouts/UpsellModalLayout/UpsellModalLayout";
import { OnePassModal } from "../OnePassModal";
import { UpsellSecondaryCTA } from "../UpsellSecondaryCTA";
import { Benefits } from "./Benefits";
import { DivisionIcons } from "./DivisionIcons";
import { Pricing } from "./Pricing";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var UpsellModal = function UpsellModal(_ref) {
  var _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      onClose = _ref.onClose,
      isFreeTrialEligible = _ref.isFreeTrialEligible,
      showSecondaryCTA = _ref.showSecondaryCTA,
      mainCTAHref = _ref.mainCTAHref,
      onMainCTAClick = _ref.onMainCTAClick,
      onLearnMoreClick = _ref.onLearnMoreClick,
      isLoggedIn = _ref.isLoggedIn,
      secondaryCTAProps = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(OnePassModal, {
    sizeVariant: {
      xs: "x-small",
      md: "small"
    },
    isOpen: isOpen,
    onRequestClose: onClose
  }, ___EmotionJSX(ContentZone, null, ___EmotionJSX(Heading.h2, {
    fontWeight: "bold",
    m: 0
  }, "Join", ___EmotionJSX(IconOnePass, {
    height: "1em",
    width: "auto",
    color: "onePass.primary",
    "aria-label": "OnePass",
    mt: -2,
    ml: 1
  })), ___EmotionJSX(Text, {
    fontSize: "base",
    fontWeight: "medium",
    textAlign: "center",
    my: 4
  }, "Enjoy a range of benefits from your favourite retail brands."), ___EmotionJSX(DivisionIcons, null), ___EmotionJSX(Benefits, null), ___EmotionJSX(Pricing, null), ___EmotionJSX(Span, {
    fontSize: {
      xs: "xs",
      md: "base"
    },
    fontWeight: "medium",
    textAlign: "center",
    color: "textTertiary"
  }, "Cancel anytime.", " ", isFreeTrialEligible && "Billing starts at end of trial."), ___EmotionJSX(LinkButton, {
    mt: 4,
    href: mainCTAHref,
    variant: "onePassPrimary",
    sizeVariant: "md",
    fontWeight: "semibold",
    textTransform: "uppercase",
    whiteSpace: "wrap",
    onClick: onMainCTAClick
  }, isFreeTrialEligible ? "Start free ".concat(DEFAULT_FREE_TRIAL_DAYS, " day trial") : "Join OnePass today"), showSecondaryCTA && ___EmotionJSX(UpsellSecondaryCTA, _extends({
    isLoggedIn: isLoggedIn
  }, secondaryCTAProps)), ___EmotionJSX(Link, {
    fontWeight: "bold",
    fontSize: "xs",
    mt: 4,
    color: "onePass.primary",
    href: URL_ONEPASS_LANDING,
    target: "_blank",
    textTransform: "capitalize",
    textDecoration: "underline",
    onClick: onLearnMoreClick
  }, "Learn more")));
};